import { Component, Input } from '@angular/core';
import {NgClassType} from "../../model/common.model";
import {NgClass, NgIf} from "@angular/common";
import {RouterLink} from "@angular/router";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";


@Component({
  selector: 'manage-button',
  standalone: true,
  imports: [
    NgClass,
    NgIf,
    RouterLink,
    MatIconModule,
    MatButtonModule
  ],
  templateUrl: './manage-button.component.html'
})
export class ManageButtonComponent {

  @Input() routerLink: any[] | string | null | undefined = ['./manage']
  @Input() isExisting: boolean = false
  @Input() ngClass: NgClassType
  @Input() buttonNgClass: NgClassType
  @Input() useLinkButton = false
  @Input() disabled = false

  constructor(
  ) { }
}

